import { createApp, ref } from "vue";

import modal from "../vue-components/modal.vue";

import VueMask from "@devindex/vue-mask";

// Tire Search Modal Component
const searchModal = createApp(modal);
searchModal.use(VueMask)
searchModal.mount("#tire-search-modal");
